import { Brand } from '@lendi/lala-react';

export const TEAM_ROLES_FOR_F2F_APPT = [
  'HLC OS Phone Sales NSW',
  'HLC OS Phone Sales QLD',
  'HLC OS Phone Sales SA',
  'HLC OS Phone Sales VIC',
  'HLC OS Phone Sales WA',
  'HLC Phone Sales NSW',
  'HLC Phone Sales QLD',
  'HLC Phone Sales SA',
  'HLC Phone Sales VIC',
  'HLC Phone Sales WA',
  'Partner Broker Manager QLD',
  'Partner Broker Manager WA',
  'Development Team',
];

const brokerTeamRole = {
  label: 'Broker',
  value: 'Broker',
};

const SLRTeamRole = {
  label: 'SLR',
  value: 'SLR',
};

const SRMTeamRole = {
  label: 'SRM',
  value: 'SRM',
};

export type ThirdPartyTeamRoles = {
  [B in Brand]: {
    label: string;
    value: string;
  }[];
};

export const THIRD_PARTY_TEAM_ROLES: ThirdPartyTeamRoles = {
  [Brand.Lendi]: [brokerTeamRole, SLRTeamRole, SRMTeamRole],
  [Brand.Aussie]: [brokerTeamRole],
};
